import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuoteCollation, QuoteCollationVap, QuotePageDataVaps} from '../../../models/quote.model';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';
import {Question} from '../../../models/underwriter.model';
import {GlobalQuestionService} from '../../../services/global-question.service';

declare var $: any;

@Component({
    selector: 'app-vaps-general-nine',
    templateUrl: './vaps-general-nine.component.html',
    styleUrls: ['./vaps-general-nine.component.scss'],
    standalone: false
})
export class VapsGeneralNineComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() collations: QuoteCollation[];
  @Input() collation_vaps: QuoteCollationVap[];
  @Input() question: Question;
  @Input() currentVap: QuotePageDataVaps;
  @Input() productId: any;
  @Input() sessionId: any;
  @Input() addAnother = false;
  @Input() addAddons = false;
  @Output() amountChanged = new EventEmitter<any>();
  @Output() addAnotherChanged = new EventEmitter<boolean>();
  @Output() addAddonsChanged = new EventEmitter<boolean>();
  maskOptions: NgxCurrencyConfig;
  vaps = [];

  constructor(public globalQuestionService: GlobalQuestionService) {

  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: this.currentVap?.value_max,
      min: null,
      allowZero: this.currentVap?.value_min === 0,
      nullable: true,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: this.globalQuestionService.currency.symbol,
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.addAnother?.currentValue === true) {
      this.addAnotherItem();
      this.addAnotherChanged.emit(false);
    }
    if (changes?.addAddons?.currentValue === true) {
      this.calculate();
      this.addAnotherChanged.emit(false);
    }
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
    }
    if (changes?.collations?.currentValue) {
      this.collations = changes?.collations?.currentValue;
    }
    if (changes?.collation_vaps?.currentValue) {
      this.collation_vaps = changes?.collation_vaps?.currentValue;
    }
    if (changes?.currentVap?.currentValue) {
      this.currentVap = changes?.currentVap?.currentValue;
    }
    if (changes?.productId?.currentValue) {
      this.productId = changes?.productId?.currentValue;
    }
    if (changes?.productId?.currentValue || changes?.currentVap?.currentValue
      || changes?.collation_vaps?.currentValue || changes?.collations?.currentValue
      || changes?.question?.currentValue) {
      this.amountChanged.emit(this.vaps);
      this.vaps = [];
      this.getProductDetails();
    }
  }

  getProductDetails(): any {
    if (this.getVapPrice(this.currentVap)) {
      for (const v of this.collation_vaps) {
        const item = {
          description: [],
          name: '',
          surname: '',
          session_item_id: '1',
          price: 0,
          selectedOption: '',
          benefit_value: 0,
          show: true
        };
        if (this.currentVap?.product_vaps_id === v?.product_vaps_id && v?.select === 1) {
          item.description = v?.detail.substring(0, v.detail.indexOf('|')).split('_');
          item.session_item_id = v?.session_item_id ? v?.session_item_id : '1';
          item.price = v?.premium ? v?.premium : 0;
          item.selectedOption = v?.option_id.toString();
          item.benefit_value = v?.benefit_value ? v?.benefit_value : 0;
          item.name = item?.description?.length ? item?.description[0] : '';
          item.surname = item?.description?.length ? item?.description[1] : '';
          item.show = false;
          this.vaps.push(item);
        }
      }
    } else {
      this.addAnotherItem();
    }
  }

  addAnotherItem(): void {
    let item_id = 1;
    $(`#addon-${this.vaps?.length}`).click();
    if (this.vaps?.length) {
      item_id = this.vaps?.length + 1;
    }
    const item = {
      description: [],
      name: '',
      surname: '',
      session_item_id: item_id.toString(),
      price: 0,
      selectedOption: '',
      benefit_value: 0,
      show: true
    };

    this.vaps.push(item);
  }

  calculate(): void {
    for (let i = 0; i < this.vaps?.length; i++) {
      this.onChange(i, 1);
    }
  }

  selectChange(value: Question, index: number): void {
    this.vaps[index].selectedOption = value?.answer;
    this.onChange(index, 0);
  }

  getVapPrice(v: QuotePageDataVaps): string {
    let price = '';
    for (const c of this.collations) {
      if (v.product_vaps_id === c.vaps_id) {
        price = c.prem_value.toString();
      }
    }
    return price;
  }

  onChange(index: number, action: number): void {
    if (this.vaps[index]?.name && this.vaps[index]?.surname && this.vaps[index]?.selectedOption && this.vaps[index]?.benefit_value && this.vaps[index]?.benefit_value >= this.currentVap.value_min) {
      if (action === 1) {
        this.globalQuestionService.spinner(true);
      }
      const answer = action.toString() + '|' + this.vaps[index]?.name + '|' + this.vaps[index]?.surname + '|' + this.vaps[index]?.selectedOption.toString() + '|' + this.vaps[index]?.benefit_value.toString();
      this.question.answer = answer;
      this.globalQuestionService.saveAnswer(this.sessionId, this.question?.cent_aq_question_id, 1, this.vaps[index]?.session_item_id, answer, 0, '')
        .subscribe(() => {

            this.globalQuestionService.calcPremiumAddons(this.currentVap?.product_vaps_id, this.vaps[index]?.session_item_id, this.productId)
              .subscribe((p: any[]) => {
                if (p?.length) {
                  p?.forEach(item => {
                    if (this.vaps[index].session_item_id === item?.session_item_id) {
                      this.vaps[index].price = item?.premium;
                    }
                  });
                  this.amountChanged.emit(this.vaps);
                  this.globalQuestionService.spinner(false);
                  this.globalQuestionService.resetVaps(false);
                }
              });

        });
    } else {
      this.vaps[index].price = 0;
      this.amountChanged.emit(this.vaps);
    }

  }
}
